"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _routing = require("@engaging-tech/routing");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _ResponsiveDisplay = require("../ResponsiveDisplay/ResponsiveDisplay");

var _index = require("../../utils/index");

var _MotionFlex = _interopRequireDefault(require("../motionComponents/MotionFlex/MotionFlex"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

/* eslint-disable react/jsx-props-no-spreading */
var reactStringReplace = require("react-string-replace");

var NoShrink = (0, _styledComponents["default"])(_MotionFlex["default"]).withConfig({
  displayName: "SectionPoint__NoShrink",
  componentId: "dez1o4-0"
})(["flex-shrink:0;"]);

var CircleIcon = function CircleIcon(_ref) {
  var name = _ref.name,
      size = _ref.size,
      _ref$bg = _ref.bg,
      bg = _ref$bg === void 0 ? "secondary.1" : _ref$bg,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "dark.2" : _ref$color,
      _ref$ICON_SIZE_RATIO = _ref.ICON_SIZE_RATIO,
      ICON_SIZE_RATIO = _ref$ICON_SIZE_RATIO === void 0 ? 1.666667 : _ref$ICON_SIZE_RATIO,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["name", "size", "bg", "color", "ICON_SIZE_RATIO"]);

  var getIconSize = function getIconSize(circleSize) {
    return Math.round(circleSize / ICON_SIZE_RATIO);
  };

  return _react["default"].createElement(NoShrink, (0, _extends2["default"])({
    borderRadius: 99,
    justifyContent: "center",
    alignItems: "center",
    width: size + "px",
    height: size + "px",
    bg: bg
  }, props), _react["default"].createElement(_Icon["default"], {
    name: name,
    size: getIconSize(size),
    color: color
  }));
};

var ButtonText = (0, _styledComponents["default"])(_Text["default"]).withConfig({
  displayName: "SectionPoint__ButtonText",
  componentId: "dez1o4-1"
})(["font-size:16px;font-weight:700;font-family:\"Centra Bold\";text-transform:uppercase;color:", ";"], function (_ref2) {
  var theme = _ref2.theme,
      textColor = _ref2.textColor,
      yellowText = _ref2.yellowText;

  if (textColor) {
    return (0, _index.colorStringToTheme)(theme, textColor);
  }

  return yellowText ? theme.colors.yellow[0] : theme.colors.dark[2];
});
var LinkText = (0, _styledComponents["default"])(_Text["default"]).withConfig({
  displayName: "SectionPoint__LinkText",
  componentId: "dez1o4-2"
})(["color:", ";cursor:pointer;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary[0];
});

var remapText = function remapText(_ref4) {
  var text = _ref4.text,
      _ref4$boldTexts = _ref4.boldTexts,
      boldTexts = _ref4$boldTexts === void 0 ? [] : _ref4$boldTexts,
      _ref4$linkedTexts = _ref4.linkedTexts,
      linkedTexts = _ref4$linkedTexts === void 0 ? [] : _ref4$linkedTexts;
  var localText = text;

  if (boldTexts && Array.isArray(boldTexts) && boldTexts.length > 0) {
    localText = boldTexts.reduce(function (outputText, boldText, i) {
      return reactStringReplace(outputText, boldText, function (match) {
        return _react["default"].createElement(_Text["default"], {
          fontFamily: "Centra Bold",
          fontSize: "inherit",
          color: "inherit",
          key: match + i
        }, match);
      });
    }, localText);
  }

  if (linkedTexts && Array.isArray(linkedTexts) && linkedTexts.length > 0) {
    localText = linkedTexts.reduce(function (outputText, _ref5, i) {
      var linkedText = _ref5.linkedText,
          linkTo = _ref5.linkTo,
          style = _ref5.style,
          onClick = _ref5.onClick,
          externalLink = _ref5.externalLink;
      return reactStringReplace(outputText, linkedText, function (match) {
        if (onClick) {
          return _react["default"].createElement(LinkText, {
            key: match + i,
            onClick: onClick,
            style: (0, _extends2["default"])({
              fontSize: 18,
              fontWeight: 700
            }, style)
          }, match);
        }

        if (externalLink) {
          return _react["default"].createElement("a", {
            href: linkTo,
            key: match + i,
            target: "_blank"
          }, _react["default"].createElement(LinkText, {
            key: match + i,
            style: (0, _extends2["default"])({
              fontSize: 18,
              fontWeight: 700
            }, style)
          }, match));
        }

        return _react["default"].createElement(_routing.Link, {
          to: linkTo,
          key: match + i,
          target: "_blank"
        }, _react["default"].createElement(LinkText, {
          key: match + i,
          style: (0, _extends2["default"])({
            fontSize: 18,
            fontWeight: 700
          }, style)
        }, match));
      });
    }, localText);
  }

  return localText;
};

var SectionPoint = function SectionPoint(_ref6) {
  var title = _ref6.title,
      texts = _ref6.texts,
      icon = _ref6.icon,
      buttons = _ref6.buttons,
      boldTexts = _ref6.boldTexts,
      linkedTexts = _ref6.linkedTexts,
      _ref6$textProps = _ref6.textProps,
      textProps = _ref6$textProps === void 0 ? {} : _ref6$textProps,
      _ref6$titleProps = _ref6.titleProps,
      titleProps = _ref6$titleProps === void 0 ? {} : _ref6$titleProps,
      _ref6$displayComponen = _ref6.displayComponentLeft,
      displayComponentLeft = _ref6$displayComponen === void 0 ? false : _ref6$displayComponen,
      _ref6$AdditionalConte = _ref6.AdditionalContentComponent,
      AdditionalContentComponent = _ref6$AdditionalConte === void 0 ? null : _ref6$AdditionalConte,
      DisplayComponent = _ref6.DisplayComponent,
      _ref6$infoColumnProps = _ref6.infoColumnProps,
      infoColumnProps = _ref6$infoColumnProps === void 0 ? {} : _ref6$infoColumnProps,
      _ref6$iconProps = _ref6.iconProps,
      iconProps = _ref6$iconProps === void 0 ? {} : _ref6$iconProps,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref6, ["title", "texts", "icon", "buttons", "boldTexts", "linkedTexts", "textProps", "titleProps", "displayComponentLeft", "AdditionalContentComponent", "DisplayComponent", "infoColumnProps", "iconProps"]);
  return _react["default"].createElement(_Flex["default"], (0, _extends2["default"])({
    flexDirection: ["column", "row"],
    width: 1 / 1,
    alignItems: "center"
  }, props), displayComponentLeft && _react["default"].createElement(_ResponsiveDisplay.TabletUp, null, DisplayComponent), _react["default"].createElement(_Flex["default"], (0, _extends2["default"])({
    flexDirection: "column"
  }, infoColumnProps), _react["default"].createElement(_Flex["default"], {
    alignContent: "center",
    alignItems: "center"
  }, icon && _react["default"].createElement(CircleIcon, (0, _extends2["default"])({
    name: icon,
    size: 50
  }, iconProps)), _react["default"].createElement(_Text["default"], (0, _extends2["default"])({
    fontFamily: "Centra Bold",
    fontSize: [28, 30],
    ml: icon ? 3 : 0,
    color: "dark.1"
  }, titleProps), title)), _react["default"].createElement(_ResponsiveDisplay.MobileOnly, {
    width: "100%"
  }, _react["default"].createElement(_Flex["default"], {
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    width: "100%"
  }, DisplayComponent)), Array.isArray(texts) && texts.map(function (text) {
    return _react["default"].createElement(_Text["default"], (0, _extends2["default"])({
      color: "dark.1",
      fontSize: 18,
      fontFamily: "Centra",
      mt: 20,
      key: text
    }, textProps), remapText({
      text: text,
      linkedTexts: linkedTexts,
      boldTexts: boldTexts
    }));
  }), AdditionalContentComponent && AdditionalContentComponent, buttons && _react["default"].createElement(_Flex["default"], {
    flexDirection: ["column", "row"],
    justifyContent: ["center", "flex-start"],
    alignContent: "center",
    alignItems: "center",
    width: "100%",
    py: 35
  }, buttons.map(function (button) {
    return _react["default"].createElement(_routing.Link, {
      to: button.path,
      key: button.path
    }, _react["default"].createElement(_Button["default"], (0, _extends2["default"])({
      fontFamily: "Centra Bold",
      mt: [1, 3],
      px: 4,
      width: "auto",
      height: 36,
      bg: button.bg || "secondary.0",
      leadingIcon: button.icon,
      color: button.iconColor
    }, button.style), _react["default"].createElement(ButtonText, {
      textColor: button.textColor,
      yellowText: button.yellowText
    }, button.text)));
  }))), !displayComponentLeft && _react["default"].createElement(_ResponsiveDisplay.TabletUp, null, DisplayComponent));
};

var _default = SectionPoint;
exports["default"] = _default;